interface TrackData {
  displayName: string,
  soundCloudTrackId: number,
}

interface AlbumData {
  displayName: string
  tracks: {
    [track: string]: TrackData
  }
}

interface ArtistData {
  displayName: string
  albums: {
    [album: string]: AlbumData
  }
}

export interface AllTrackData {
  [artist: string]: ArtistData
}

const allTrackData: AllTrackData = {
  'akira-the-don': {
    displayName: 'Akira the Don',
    albums: {
      'jbpwave-paradise': {
        displayName: 'JBPWAVE: Paradise',
        tracks: {
          'heaven-and-hell-part-1': {
            displayName: 'Heaven and Hell Part 1',
            soundCloudTrackId: 600010389,
          },
          'the-mysterious': {
            displayName: 'The Mysterious',
            soundCloudTrackId: 597664326,
          },
        },
      },
    },
  },
}

export default allTrackData
